import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { cabinet } from '../../api/cabinet';
import { commonSite, useCaseSite } from '../../app/caseSite';
import { ErrorBlock } from '../../components/ErrorBlock';
import { ArrowIcon } from '../../components/Icons';
import { Loading } from '../../components/Loading';
import { useI18n, useT } from '../../i18n';
import { formatDate } from '../../lib/format';
import { loc } from '../../lib/loc';
import { useAsync } from '../../lib/useAsync';
import { CaseStatus } from './FamilySteps';

export function CasesPage() {
  const t = useT();
  const locale = useI18n((s) => s.locale);
  const { data, error, loading, reload } = useAsync(() => cabinet.cases(), []);
  const publishSite = useCaseSite((s) => s.publish);
  const clearSite = useCaseSite((s) => s.clear);
  // усі справи з одного сайту (напр. лише молдовська) — список у тій самій мові й з тими самими контактами
  const shared = data ? commonSite(data.map((c) => c.site)) : null;
  useEffect(() => {
    if (shared) publishSite('list', shared);
    else clearSite('list');
  }, [shared, publishSite, clearSite]);
  useEffect(() => () => clearSite('list'), [clearSite]);

  return (
    <>
      <h1 className="text-[28px] leading-tight sm:text-[34px]">{t('cases.title')}</h1>
      {loading && !data ? <Loading /> : null}
      {error && !data ? <ErrorBlock error={error} onRetry={() => void reload()} /> : null}
      {data && data.length === 0 ? <p className="mt-8 max-w-prose text-[16px] leading-relaxed text-txt">{t('cases.empty')}</p> : null}
      {data && data.length > 0 ? (
        <ul className="mt-8 flex flex-col gap-4">
          {data.map((c) => (
            <li key={c.id}>
              <Link
                to={`/cases/${encodeURIComponent(c.id)}`}
                className="block border border-line p-5 transition-colors hover:border-lab focus-visible:border-fg sm:p-6"
              >
                <div className="flex items-baseline justify-between gap-3 text-[14px] text-lab">
                  <span>{loc(c.service_type?.name, locale)}</span>
                  {c.number != null ? <span className="whitespace-nowrap">{t('cases.number', { n: c.number })}</span> : null}
                </div>
                {c.title ? <p className="mt-3 text-[18px] leading-snug">{c.title}</p> : null}
                <CaseStatus caseId={c.id} state={c.state} states={c.states ?? []} />
                <div className="mt-4 flex items-center justify-between gap-3 text-[14px]">
                  <span className="text-lab">{t('cases.updated', { date: formatDate(c.updated_at, locale) })}</span>
                  <span className="inline-flex min-h-tap items-center gap-2">
                    {t('cases.open')} <ArrowIcon />
                  </span>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      ) : null}
    </>
  );
}
